// Microsoft Clarity tracking utilities

declare global {
  interface Window {
    clarity: (action: string, ...args: any[]) => void;
  }
}

export class ClarityTracker {
  /**
   * Check if Clarity is loaded and available
   */
  private static isAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.clarity === 'function';
  }

  /**
   * Identify user with client ID and email for Mattic
   * @param clientId - Client ID
   * @param userEmail - User email
   */
  static identifyMatticUser(
    email: string,
    clientId: string,
    userId: string,
    userType: string,
    companyName?: string
  ): void {
    if (!this.isAvailable()) {
      console.warn('Clarity is not available');
      return;
    }

    try {
      // Use email as the primary identifier
      window.clarity('identify', userId, email);

      // Set custom tags for client ID and email
      window.clarity('set', 'client', clientId);
      window.clarity('set', 'user_id', userId);
      window.clarity('set', 'role', userType);
      if (companyName) window.clarity('set', 'company_name', companyName);
    } catch (error) {
      console.error('Error identifying Mattic user in Clarity:', error);
    }
  }
}

// Export the main function for easy use
export const identifyMatticUser = ClarityTracker.identifyMatticUser.bind(ClarityTracker);
